import { createService } from '@betty/toolkit/api';
import { RegistrationResponseSchema } from './RegistrationService.schemas';

export default createService({
  register: {
    method: 'POST',
    url: '/Registration',
    headers: {
      'X-Registration-Version': 'v2',
    },
    responseSchema: RegistrationResponseSchema,
  },
});
